import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	question: Yup.string().required().label('Question'),
	answer: Yup.string().required().label('Answer'),
});

const Inputs = [
	{
		name: 'question',
		label: 'Question',
		type: 'text',
		value: 'single',
		valueAttr: 'question',
		required: true,
	},
	{
		name: 'answer',
		label: 'Answer',
		type: 'textarea',
		value: 'single',
		valueAttr: 'answer',
		required: true,
	}
];

export { Inputs, validationSchema };
